var CACHE_NAME = "audioCache";
var PlayerCache = /** @class */ (function () {
    function PlayerCache() {
    }
    PlayerCache.loadURL = function (url) {
        if (!PlayerCache.ENABLED) {
            return;
        }
        window.caches && window.caches.open(CACHE_NAME).then(function (cache) {
            cache.add(url).catch(function (err) {
            });
            return null;
        });
    };
    PlayerCache.redirectMediaUrl = function (url) {
        if (url && 'serviceWorkerAvailable' in window) {
            return location.protocol + "//" + location.host + "/media-stream/" + encodeURIComponent(url);
        }
        return url;
    };
    PlayerCache.ENABLED = true;
    return PlayerCache;
}());
export { PlayerCache };
//# sourceMappingURL=PlayerCache.js.map